module.exports = __webpack_public_path__ + "static/img/SNSW-logo.28b72e28.svg";